<template>
  <div>
    <!-- Date Picker | Seleção de data para checkin e checkout -->
    <div class="input-group">

      <div class="w-100 text-center text-primary font-strong mb-2">{{ title }}:</div>

      <HotelDatePicker
        ref="calendar"
        format="DD-MM-YYYY"
        :startDate="startDate"
        :i18n="datePickerPtBr"
        :disabledDates='allowedDates'
        :displayClearButton="clearButton"
        @check-in-changed="updateCheckIn"
        class="datepicker__mini get-dates"
        :class="{'disabled' : disabled }"
        @check-out-changed="updateCheckOut"
        :closeDatepickerOnClickOutside="false"
      />
    </div>
  </div>
</template>

<script>

import HotelDatePicker from 'vue-hotel-datepicker';

export default {
  name: 'SelectDates',
  components: {
    HotelDatePicker
  },
  props: {
    title: {
      type: String,
      default: 'Pedalar nos dias'
    },
    dataBike: {
      type: Object
    },
    dataOrder: {
      type: Object
    },
    clearButton: {
      type: Boolean,
      default: true
    },
     disabled: Boolean
  },

  data() {
    return {
      bookingDates: {
        dateCheckin: '',
        dateCheckout: ''
      },
      availableDates: [],
      allowedDates: [],
      endDate: this.getEndDay,
      startDate: this.getFirstDay,
      datePickerPtBr: {
        night: 'Diária',
        nights: 'Diárias',
        'day-names': ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
        'check-in': 'De',
        'check-out': 'Até',
        'month-names': ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      },
      dataBikeTemp: {},
      calendarOpen: this.stateCalendar
    }
  },

  mounted() {
    if (this.dataBike.availableDates) {

      if (this.dataBike.rented) {
        this.handleAvailableDates(this.dataBike)

      } else {
        this.availableDates = this.dataBike.availableDates
      }
    }

  },

  methods: {
    handleAllowedDates(dates) {
      if (dates) {
        this.endDate = this.getEndDay;

        // gera X dias e retorna somente os dias disponíveis para locação
        this.allowedDates = this.generateArrayDays(360).filter((e) => {

          let date = new Date(e);

          return this.availableDates.includes(this.$moment(date).format("YYYY-MM-DD"))

        });

      }
    },

    genListDatesBetweenStartAndEnd(dates) {
      let tempArr = []

      if (dates) {
        dates.map((v) => {
          let checkin = this.$moment(v.period.checkin);
          let checkout = v.period.checkout;


          while (!this.$moment(checkin).isSame(this.$moment(checkout).add(1, 'days'))) {
            checkin = this.$moment(checkin).add(1, 'days')
            tempArr.push(checkin.format("YYYY-MM-DD"))
          }
        })
      }

      return tempArr
    },

    thereIsNextDay(day) {

      let startDay = this.$moment(day).format("YYYY-MM-DD");
      let arr = [];

      let indexDay = this.availableDates.indexOf(startDay)

      this.availableDates.forEach((v, index) => {
        if (index >= indexDay) {

          let addDays = new Date(v);
          let moreOneday = this.$moment(addDays.setDate(addDays.getDate() + 2)).format("YYYY-MM-DD")

          if (!this.availableDates.includes(moreOneday)) {
            arr.push(moreOneday)
          }
        }
      })

      return arr
    },

    // Obtem a data de checkin do calendario e injeta em this.bookingDates.dateCheckin
    updateCheckIn(date) {
      let addDays = new Date(date);
      this.startDate = this.$moment(addDays.setDate(addDays.getDate() + 2)).format("YYYY-MM-DD")

      setTimeout(() => {
        this.clearDates();
      }, 20)


      if (date) {

        this.$emit('open', this.$refs.calendar.isOpen);

        //this.endDate = this.thereIsNextDay(date)[0]

        this.$refs.calendar.reRender()

        this.bookingDates.dateCheckin = this.$moment(date).format("YYYY-MM-DD");

        if (window.innerWidth < 560) {
           setTimeout(() => {
              this.$alert('', 'Agora, selecione a data de entrega', {
                 confirmButtonText: 'OK'
              })
           }, 300)
        }


      } else {
        this.endDate = this.getEndDay
      }


    },

    // Obtem a data de checkout do calendario e injeta em this.bookingDates.dateCheckout
    updateCheckOut(date) {

      setTimeout(() => {
        this.clearDates();
      }, 20)

      this.fixIndex = false;
      if (date) {
        this.bookingDates.dateCheckout = this.$moment(date).format("YYYY-MM-DD");

        let dNumber = this.dailyNumber()

        this.endDate = this.generateEndDate(dNumber);

        this.$store.dispatch('selectDates/setDates', {
          dateCheckin: this.bookingDates.dateCheckin,
          dateCheckout: this.bookingDates.dateCheckout
        });
      }
    },

    upDateCalendar() {
      if (this.allowedDates.length > 1) {
        this.$refs.calendar.reRender()
        this.$refs.calendar._data.sortedDisabledDates = this.allowedDates
      }
    },

    checkDatesInLocalStorage() {
      if (localStorage.getItem('bike_checkout')) {
        try {
          this.dataStored = JSON.parse(localStorage.getItem('bike_checkout'));
        } catch (e) {
          localStorage.removeItem('bike_checkout');
          this.dataStored = null
        }
      }
    },

    clearDates() {
      let calendar = document.querySelector('.datepicker__clear-button')
      if (calendar) {
        this.startDate = this.$moment().format("YYYY-MM-DD")
        calendar.addEventListener("click", () => {
          //alert(1)
          this.$refs.calendar.reRender()
          this.bookingDates.dateCheckin = ''
          this.bookingDates.dateCheckout = ''
          this.startDate = this.$moment().format("YYYY-MM-DD")
          this.onClearDates = true;
          this.$store.dispatch('selectDates/clearDates');
        })
      }
    },

    resetCalendar() {
      this.bookingDates.dateCheckin = ''
      this.bookingDates.dateCheckout = ''
      this.startDate = this.$moment().format("YYYY-MM-DD")
      this.onClearDates = true;
      this.$store.dispatch('selectDates/setDates', {
        dateCheckin: '',
        dateCheckout: ''
      });
      this.$emit('open', this.$refs.calendar.isOpen);
      //this.$refs.calendar.clearSelection()
    },

    close() {
        this.$refs.calendar.isOpen = false
    },

    allEqual(arr1, arr2) {
      return JSON.stringify(arr1) === JSON.stringify(arr2);
    },

    getStorageData(e) {

      if (e && e.bike._id === this.bike._id && this.allEqual(e.availableDates, this.availableDates)) {

        let checkIn = new Date(e.bookingDates.dateCheckin);
        checkIn.setDate(checkIn.getDate() + 1);
        this.$refs.calendar.setCheckIn(checkIn);

        let checkOut = new Date(e.bookingDates.dateCheckout);
        checkOut.setDate(checkOut.getDate() + 1);
        this.$refs.calendar.setCheckOut(checkOut);
      }
    },

    generateArrayDays(days) {
      Date.prototype.addDays = function (days) {
        let dat = new Date(this.valueOf())
        dat.setDate(dat.getDate() + days);
        return dat;
      }

      function getDates(startDate, stopDate) {
        let dateArray = [];
        let currentDate = startDate;
        while (currentDate <= stopDate) {
          dateArray.push(currentDate)
          currentDate = currentDate.addDays(1);
        }
        return dateArray;
      }

      let arrDates = []
      let dateArray = getDates(new Date(), (new Date()).addDays(days));
      for (let i = 0; i < dateArray.length; i++) {
        arrDates.push(this.$moment(dateArray[i]).format("YYYY-MM-DD"))
      }

      return arrDates
    },

    generateEndDate(days) {
      let addDays = new Date();
      return this.$moment(addDays.setDate(addDays.getDate() + days)).format("YYYY-MM-DD")
    },

    dailyNumber() {
      return this.$moment(this.availableDates.slice(-1)[0]).diff(this.availableDates[0], 'days');
    },

    handleAvailableDates(dataBike) {
      let tempDate = []

      // Somente as datas que não são da reserva do Ciclista serão inclusas no range de datas de disponibilidade. Usado para permitir a seleção de datas em atualizar datas de reserva, em minhas reservas, a fim de o cliente poder escolher outras datas, além das que ele já reservou.
      dataBike.rented.map((v) => {


        if  (this.dataOrder) {
          // usado dentro do pedido em minhas-reservas/(modal)reserva

          if (v.customer._id !== this.currentUser.user._id || v._id !== this.dataOrder._id) {
            tempDate.push(v)
          }
        } else {
          // Usado no site público como em /bicicleta/bike-123

          /*if (v.customer._id !== this.currentUser.user._id) {
            tempDate.push(v)
          }*/
          tempDate.push(v)
        }
      })

      this.availableDates = dataBike.availableDates.filter((f) => {
        return !this.genListDatesBetweenStartAndEnd(this.$route.name === 'my-reservations' ? tempDate : dataBike.rented).includes(f)
      })

    }

  },

  computed: {
    checkDates() {
      return this.bookingDates.dateCheckin === this.bookingDates.dateCheckout ||
        this.bookingDates.dateCheckin === '';
    },

    getEndDay() {
      if (!this.availableDates) {
        return false
      }
      let lastDayOfAvailability = this.availableDates.slice(-1).pop();
      return this.$moment(lastDayOfAvailability).add(4, 'days').format("YYYY-MM-DD");
    },

    getFirstDay() {
      if (!this.availableDates) {
        return false
      }
      let firstDayOfAvailability = this.availableDates[0];
      return this.$moment(firstDayOfAvailability).format("YYYY-MM-DD");
    },

    currentUser() {
      return this.$store.state.auth.user;
    }
  },

  watch: {

    // eslint-disable-next-line no-unused-vars
    availableDates: function (n) {
     this.handleAllowedDates(n)
    },

    'bookingDates.dateCheckin': function (n) {
      //let addDays = new Date(n);
      if (n) {
        if (this.dataStored?.availableDates) {

          if (this.dataStored.bike._id === this.bike._id) {
            this.startDate = this.$moment().format("YYYY-MM-DD")
            delete this.dataStored
          }

        }
      }
    },

    allowedDates: function (e) {
      if (e) {
        this.upDateCalendar();
      }
    },

    dataBike: function (e) {
      if (e) {

        if (e.availableDates) {

          if (e.rented) {

            this.handleAvailableDates(e)

          } else {

           this.availableDates = e.availableDates

          }
        }
      }
    }
  }
};
</script>

<style scoped>
.disabled::after {
   content: '';
   position: absolute;
   background: rgba(255, 255, 255, 0.5);
   width: 100%;
   height: 42px;
   left: 0;
   top: 0;
}
</style>
